import React, { useRef, useState, useEffect, forwardRef, useImperativeHandle } from 'react'
import moment from 'moment'
import axios from '../../plugins/axios'
import Calendar from 'react-calendar'
import { useRecoilState } from 'recoil'
import { useTranslation } from 'react-i18next'
import { selectBedInfoState,isFromSearchState } from '../../plugins/recoil'

import {ReactComponent as IconArrowRight} from '../../assets/icons/ic-arrow-right.svg'
import {ReactComponent as IconArrowLeft} from '../../assets/icons/ic-arrow-left.svg'
import {ReactComponent as IconClose} from '../../assets/icons/ic-close.svg'
import {ReactComponent as IconArrowUp} from '../../assets/icons/ic-arrow-up.svg'
import {ReactComponent as IconArrowDown} from '../../assets/icons/ic-arrow-down.svg'
import {ReactComponent as IconCheck} from '../../assets/icons/ic-check_blue.svg';
import { set } from 'lodash'

const TimelineDateModal = forwardRef(({ handleClose, handleSearch }, ref) => {
    const { t } = useTranslation()
    const localRef = useRef(null);
    const selectRef = useRef(null);
    const [calendarAlarms, setCalendarAlarms] = useState([])
    const [selectBedInfo] = useRecoilState(selectBedInfoState)
    const [isFromSearch] = useRecoilState(isFromSearchState)
    const [editStartDate, setEditStartDate] = useState(new Date())
    const [editEndDate, setEditEndDate] = useState(new Date())    
    const [editDate, setEditDate] = useState()
    const [editHour, setEditHour] = useState(0);
    const [editMinute, setEditMinute] = useState(0);
    const [activeStartDate, setActiveStartDate] = useState(new Date())       

    const TileContent = ({ activeStartDate, date, view }) => {        
        const formattedDate = moment(date).format('YYYY-MM-DD');
        const alarm = calendarAlarms.find(alarm => alarm.date === formattedDate);
        const isSelect = moment(editDate).format('YYYY-MM-DD') === moment(date).format('YYYY-MM-DD')
        
        if (alarm) alarm.priority.sort((a, b) => b - a)
        if (isSelect) {
            return (
                <>                    
                    <div className="absolute bg-gradient-to-b from-[#3182F7] to-[#1562D1]" style={{ top: 3, width: 32, height: 32, borderRadius: 6, zIndex: -1 }} />
                    {
                        alarm &&
                        <div className="flex items-center justify-center">
                            {
                                alarm.priority.map((priority, index) => {
                                    let bgColor = priority === 2 ? '#FF002E' : (priority === 1 || priority === 0) ? '#FFF500' : '#FFFFFF';
                                    return <div className="w-[4px] h-[4px] mr-1" key={`${date}-alarm-${index}`} style={{ borderRadius: 3, backgroundColor: bgColor }} />
                                })
                            }
                        </div>
                    }
                </>
            )
        } else {
            return (
                <>
                    {
                        alarm &&
                        <div className="flex items-center justify-center">
                            {
                                alarm.priority.map((priority, index) => {
                                    let bgColor = priority === 2 ? '#FF002E' : (priority === 1 || priority === 0) ? '#FFF500' : '#FFFFFF';
                                    return <div className="w-[4px] h-[4px] mr-1" key={`${date}-alarm-${index}`} style={{ borderRadius: 3, backgroundColor: bgColor }} />
                                })
                            }
                        </div>
                    }
                </>
            )
        }
    }

    const tileDisabled = ({ date, view }) => {
        if (isFromSearch) {
            const histories = selectBedInfo.deviceHistory || [];
            const periods = [];
            let currentPeriod = null;
            histories.forEach(h => {
                if (h.action === 'ADMITTED') {
                    currentPeriod = { start: moment(h.createdAt), end: null };
                } else if (h.action === 'UNASSIGNED' && currentPeriod) {
                    currentPeriod.end = moment(h.createdAt);
                    periods.push(currentPeriod);
                    currentPeriod = null;
                }
            });
            // 마지막 입원이 퇴원 없이 끝났으면 현재까지로 처리 (오늘 제외)
            if (currentPeriod && !currentPeriod.end) {
                currentPeriod.end = moment().subtract(1, 'days');
                periods.push(currentPeriod);
            }

            // 오늘 날짜는 선택 불가
            const isInPeriod = periods.some(period =>
                moment(date).isSameOrAfter(period.start, 'day') &&
                moment(date).isSameOrBefore(period.end, 'day')
            );
            return !isInPeriod;
        }

        const isFuture = moment(date).isAfter(moment());
        return isFuture;
    };

    const getCalendarAlarms = async (val) => {        
        try {
            const res = await axios.get(`/trend/alarm/event/calendar?serialNo=${selectBedInfo.serial}&startTime=${moment(val).startOf('month').format('YYYY-MM-DDTHH:mm:ss')}Z&endTime=${moment(val).endOf('month').format('YYYY-MM-DDTHH:mm:ss')}Z`)
            setCalendarAlarms(res.data.events)
            console.log(val);
        } catch (err) {
            console.warn(err)
            setCalendarAlarms([])
        }
    }

    // Search Alarm일 경우
    const getSearchCalendarAlarms = async (val) => {
        try{
            //moment(val) 현재 달인데 환자의 입퇴원 시간을 alarms로 가져와야 할듯
            // 환자의 입퇴원 시간은 selectBedInfo의 deviceHistory에 Array로 있으며, Array안에는 
            // action / createdAt / deviceId / devicePatientId / patientId / patientName / serial이 있으며
            // action은 ADMITTED와 UNASSIGNED로 되어있음
            // createdAt은 시간정보가 들어있는데 ADMITTED / UNASSIGNED 시간임
            // serial 번호로 api 호출을 하여야 하니 이 3가지를 가장 중점으로 데이터로 비교해야됨.

            //환자 히스토리를 가져와서 val의 있는 달의 데이터 중 해당되는 월의 데이터만 가져올 수 있게 로직 만들어줘
            //그리고 환자 히스토리는 여러개의 시리얼이 될 수도 있으니까 promise를 사용해서 여러번 가져온다음에 한번에 합쳐서 setCalendarAlarms(res.data.events) 이거처럼 넣어줄 수 있게 해줬으면 좋겠어
            //const res = await axios.get(`/trend/alarm/event/calendar?serialNo=${selectBedInfo.serial}&startTime=${moment(val).startOf('month').format('YYYY-MM-DDTHH:mm:ss')}Z&endTime=${moment(val).endOf('month').format('YYYY-MM-DDTHH:mm:ss')}Z`)
            // 1. 해당 월의 시작/끝
            const monthStart = moment(val).startOf('month');
            const monthEnd = moment(val).endOf('month');

            // 2. selectBedInfo.deviceHistory에서 해당 월에 입원한 시리얼 추출
            const histories = selectBedInfo.deviceHistory || [];
            // ADMITTED/UNASSIGNED 시간 기준으로 해당 월에 포함되는 시리얼만 추출
            const serials = histories
                .filter(h => {
                    const admitted = h.action === 'ADMITTED' && moment(h.createdAt).isBefore(monthEnd);
                    const unassigned = h.action === 'UNASSIGNED' && moment(h.createdAt).isAfter(monthStart);
                    return admitted || unassigned;
                })
                .map(h => h.serial);

            // 중복 제거
            const uniqueSerials = [...new Set(serials)];

            // 3. 각 시리얼별로 API 호출
            const promises = uniqueSerials.map(serial =>
                axios.get(`/trend/alarm/event/calendar?serialNo=${serial}&startTime=${monthStart.format('YYYY-MM-DDTHH:mm:ss')}Z&endTime=${monthEnd.format('YYYY-MM-DDTHH:mm:ss')}Z`)
            );

            // 4. 모든 결과 합치기
            const results = await Promise.all(promises);
            const allEvents = results.flatMap(res => res.data.events);

            setCalendarAlarms(allEvents);
        }
        catch(err){
            console.warn(err)
            setCalendarAlarms([])
        }
    }

    const handleChangeTimeInput = (type, e) => {
        const inputValue = e.target.value;
    
        // 숫자가 두 자리 이하인지 확인
        switch(type) {
            case 'h':
                if (/^(2[0-3]|[01]?[0-9])$/.test(inputValue) || inputValue === '') {
                    setEditHour(inputValue ? parseInt(inputValue) : '');
                }
                break;
            case 'm':
                if (/^(5[0-9]|[0-4]?[0-9])$/.test(inputValue) || inputValue === '') {
                    setEditMinute(inputValue ? parseInt(inputValue) : '');
                }
                break;
        }
    };

    const handleChkEmpty = (type,e) => {
        const inputValue = e.target.value;

        switch(type) {
            case 'h':
                setEditHour(inputValue ? parseInt(inputValue) : '00' );
                break;
            case 'm':
                setEditMinute(inputValue ? parseInt(inputValue) : '00');
                break;
        }
    }

    const handleKeyDown = (e) => {
        // 'e', '+', '-' 키 입력 방지
        if (['e', '+', '-', '.', ','].includes(e.key)) {
            e.preventDefault();
        }
    };

    const handleClickSearch = () => {
        if (
            (isFromSearch && !isDateInPatientPeriod(editEndDate)) ||
            (!isFromSearch && moment(editEndDate).isAfter(moment()))
        ) {
            return; // 버튼 동작 안함
        }
        if (!moment(editStartDate).add(24, 'hours').isAfter(moment())) {
            handleSearch(editStartDate, editEndDate, 24);
        }
    };

    const handleCalendarMove = (direction) => {        
        const newEditDate = direction === 'prev' ? new Date(moment(editDate).subtract(1, 'month')) : new Date(moment(editDate).add(1, 'month'));
        if(isFromSearch){
            getSearchCalendarAlarms(newEditDate); // Alarm 데이터 갱신 후 수정
        }else{
            getCalendarAlarms(newEditDate); // Alarm 데이터 갱신 후 수정
        }        
        setEditDate(newEditDate);
    }    

    // 환자 입퇴원 기간에 포함되는지 체크 함수
    const isDateInPatientPeriod = (date) => {
        if (!isFromSearch) return true;
        const histories = (selectBedInfo.deviceHistory || []).slice().sort((a, b) => moment(a.createdAt) - moment(b.createdAt));
        const periods = [];
        let currentPeriod = null;
        histories.forEach(h => {
            if (h.action === 'ADMITTED') {
                currentPeriod = { start: moment(h.createdAt), end: null };
            } else if (h.action === 'UNASSIGNED' && currentPeriod) {
                currentPeriod.end = moment(h.createdAt);
                periods.push(currentPeriod);
                currentPeriod = null;
            }
        });
        if (currentPeriod && !currentPeriod.end) {
            currentPeriod.end = moment().subtract(1, 'days');
            periods.push(currentPeriod);
        }
        // 'second' 단위까지 비교해서 퇴원 시간 포함
        return periods.some(period =>
            moment(date).isSameOrAfter(period.start) &&
            moment(date).isSameOrBefore(period.end, 'second')
        );
    };

    //달력 변경
    useEffect(() => {
        setActiveStartDate(editDate)
        const newDate = moment(editDate)
        newDate.set('hour', editHour)
        newDate.set('minute', editMinute)
        setEditEndDate(new Date(moment(newDate))); 
        const newStartDate = new Date(moment(newDate).subtract(24, 'hours')) 
        setEditStartDate(newStartDate)
    }, [editDate])

    //시간 체크
    useEffect(() => {
        const newDate = moment(editEndDate)  
        newDate.set('hour', editHour)
        newDate.set('minute', editMinute)        
        setEditEndDate(new Date(moment(newDate))); 
        const newStartDate = new Date(moment(newDate).subtract(24, 'hours')) 
        setEditStartDate(newStartDate)
    }, [editHour, editMinute ])

    useImperativeHandle(ref, () => ({
        init: (val) => {
            if(isFromSearch){
                getSearchCalendarAlarms(val)
            }else{
                getCalendarAlarms(val)
            }
            setEditEndDate(val)
            setEditDate(val)
            setEditHour(moment(val).get('hour'))
            setEditMinute(moment(val).get('minute'))
        },
        setDate : (startDate,endDate) => {    
            if(isFromSearch){
                getSearchCalendarAlarms(endDate)
            }else{
                getCalendarAlarms(endDate)
            }        
            setEditEndDate(endDate)
            setEditDate(endDate)
            setEditStartDate(startDate);
            setEditHour(moment(endDate).get('hour'))
            setEditMinute(moment(endDate).get('minute'))
        },
        getDom: () => localRef.current
    }));

    return (        
        <div ref={localRef} className="date-select-modal absolute w-[536px] top-1/2 left-1/2 bg-[#1F1F1F]" style={{ borderWidth: 1, borderRadius: 8, borderColor: '#5E5E5E', boxShadow: '0px 12px 12px 0px #00000099', zIndex: 11, width: 536, zIndex: 10000 ,transform: 'translate(-50%, -50%)'}}>            
            <div className="flex items-center bg-[#353535] mb-1" style={{ padding: '8px 20px', borderTopLeftRadius: 8, borderTopRightRadius: 8 }}>
                <div className="text-[#DEDEDE]" style={{ fontSize: 16 }}>{t('trend.timeRange')}</div>
                <IconClose className="ml-auto cursor-pointer" style={{ marginRight: -8 }} onClick={() => { handleClose() }}/>
            </div>
            <div className="flex px-1">
                <div className="flex flex-col flex-1 px-5" style={{  }}>
                    <div className="relative flex items-center justify-between mb-4 mt-3 text-[#fff]">
                        <IconArrowLeft className="cursor-pointer" onClick={() => { handleCalendarMove('prev') }}/>
                        <div className="flex items-center" style={{ fontWeight: 500, fontSize: 16, lineHeight: '17.6px' }}>
                            <div className="">{ moment(editDate).format('MMMM YYYY') }</div>
                        </div>
                        <IconArrowRight className="cursor-pointer" onClick={() => { handleCalendarMove('next') }}/>
                    </div>
                    <Calendar                        
                        calendarType={'gregory'}
                        showNavigation={false}
                        tileClassName={['relative', 'flex', 'flex-col', 'justify-center', 'font-white']}
                        tileContent={TileContent}
                        tileDisabled={tileDisabled}
                        formatDay={(locale, date) => moment(date).format('D')}
                        formatShortWeekday={(locale, date) =>  moment(date).format('ddd').charAt(0)}
                        locale={'en'}
                        prev2Label={null}
                        next2Label={null}
                        showNeighboringMonth={false}
                        onChange={setEditDate}
                        value={editDate}
                        maxDate={new Date()}
                        activeStartDate={activeStartDate}
                        onActiveStartDateChange={({activeStartDate}) => setActiveStartDate(activeStartDate)}
                    />
                </div>
                <div className="flex flex-col flex-1 pb-6 pr-6 gap-[6px]" style={{ maxWidth: '50%' }}>
                    <div className="mt-3 text-[#F4F4F4]" style={{ fontWeight: 300, fontSize: 14, lineHeight: '15.4px' }}>{t('trend.time')} {'('}{moment(editEndDate).format('YYYY-MM-DD')}{')'}</div>
                    <div className="flex items-center text-[#F4F4F4]">
                        <input type='number' value={editHour} onChange={(e) => {handleChangeTimeInput('h', e)}} onBlur={(e) => {handleChkEmpty('h',e)}} onKeyDown={handleKeyDown} className="flex-1 time-input" maxLength={2}/>
                            <div className="mx-2">:</div>
                        <input type='number' value={editMinute} onChange={(e) => {handleChangeTimeInput('m', e)}} onBlur={(e) => {handleChkEmpty('m',e)}} onKeyDown={handleKeyDown} className="flex-1 time-input"  maxLength={2}/>
                    </div>
                    <div className="font-light text-[#9F9F9F]" style={{ fontSize: 13 }}>{t('trend.timeRangeModalText')}</div>
                    <div className="mt-3 text-[#F4F4F4]" style={{ fontWeight: 300, fontSize: 14, lineHeight: '15.4px' }}>{t('trend.timelineDuration')}</div>
                    <div className="relative my-[5px]" ref={selectRef}>
                        <div style={{ opacity: 0.3 }} className="bg-gradient-to-b from-[#5E5E5E] to-[#383838] text-[#DEDEDE] w-[236px] h-[26px] py-[5px] px-[8px] rounded-[6px] cursor-pointer flex items-center justify-between border border-[#4E4E4E]" onClick={(e) => { e.stopPropagation();}}>
                            <div className="w-[200px]">24 {t('trend.hours')}</div>
                        </div>
                        {/* {
                            isDropdownOpen && (
                                <div className="absolute top-[30px] bg-[#1F1F1F] w-[236px] py-[8px] rounded-[6px] border border-[#5E5E5E] shadow-[0px_12px_12px_0px_rgba(0,0,0,0.4)] z-20">
                                    {
                                        timeRange.map((time,_) => (
                                            <div className={`bg-[#1F1F1F] cursor-pointer h-[32px] flex items-center justify-between px-[8px] hover:bg-[#2F2F2F] ${duration === time ? "text-[#3182F7]" : "text-white"}`} 
                                                    onClick={(e) => { e.stopPropagation(); setDuration(time); (duration != time && setIsDropdownOpen((prev) => !prev))}}
                                                    key={_}
                                            >
                                                {time} {t('trend.hours')}
                                                {duration === time && (
                                                    <IconCheck className="w-4 h-4 ml-2" />
                                                )}
                                            </div>
                                        ))
                                    }                                       
                                </div>
                            )
                        } */}
                        {/* <div className="absolute transform -translate-y-1/2 pointer-events-none top-1/2 right-2">
                            {isDropdownOpen ?  <IconArrowUp/> : <IconArrowDown/>}
                        </div> */}
                    </div>
                    <div className="mt-auto ml-auto flex items-center gap-3" style={{ fontWeight: 500, fontSize: 14, lineHeight: '15.4px' }}>
                        <div className="text-[#9F9F9F] cursor-pointer" onClick={() => { handleClose() }}>{t('trend.cancel')}</div>
                        {/* <div className="text-[#3172F7] cursor-pointer" onClick={() => { handleClickSearch() }} style={{ opacity: (!isDateInPatientPeriod(editEndDate) || moment(editEndDate).isAfter(moment())) ? 0.3 : 1 }}>{t('trend.apply')}</div> */}
                        <div className="text-[#3172F7] cursor-pointer" onClick={() => { handleClickSearch() }} style={{ opacity: ( isFromSearch ? isDateInPatientPeriod(editEndDate) : !moment(editEndDate).isAfter(moment()) ) ? 1 : 0.3 }}>{t('trend.apply')}</div>
                    </div>                    
                </div>
            </div>
        </div>
    )
})

export default TimelineDateModal